export default function init() {
  
  // Batch animation helper
  const animateBatch = (elements, staggerDelay = 100) => {
    const visibleElements = [];
    
    elements.forEach((element, index) => {
      if (element.getBoundingClientRect().top < window.innerHeight) {
        visibleElements.push({ element, index });
      }
    });
    
    visibleElements.forEach(({ element, index }) => {
      setTimeout(() => {
        element.classList.add('visible');
      }, index * staggerDelay);
    });
  };
  
  // ANY ELEMENT INTRO GENERIC
  const elementsIntro = document.querySelectorAll(".element-intro");
  
  if (elementsIntro.length > 0) {
    const elementObserver = new IntersectionObserver((entries) => {
      const toAnimate = [];
      
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('visible')) {
          toAnimate.push(entry.target);
        }
      });
      
      // Batch animate all visible elements with stagger
      if (toAnimate.length > 0) {
        animateBatch(toAnimate, 100);
      }
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });
    
    elementsIntro.forEach(element => {
      elementObserver.observe(element);
    });
  }
  
  // DIVIDER INTRO GENERIC
  const linesIntro = document.querySelectorAll(".lines-intro");
  
  if (linesIntro.length > 0) {
    const lineObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.1
    });
    
    linesIntro.forEach(element => {
      lineObserver.observe(element);
    });
  }
  
  // TEXT INTRO BY WORDS/LETTERS
  const textSplitted = document.querySelectorAll(".text-splitted");
  
  if (textSplitted.length > 0) {
    const textObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
          const letters = entry.target.querySelectorAll(".letter");
          
          letters.forEach((letter, index) => {
            setTimeout(() => {
              letter.classList.add('visible');
            }, index * 100); // 0.1s stagger between letters
          });
          
          entry.target.classList.add('animated');
        }
      });
    }, {
      threshold: 0.1
    });
    
    textSplitted.forEach(element => {
      textObserver.observe(element);
    });
  }
  
  // Also handle .text-fade-in elements if they exist
  const textFadeIn = document.querySelectorAll(".text-fade-in");
  
  if (textFadeIn.length > 0) {
    const fadeObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.1
    });
    
    textFadeIn.forEach(element => {
      fadeObserver.observe(element);
    });
  }
  
  console.log('Animation system initialized');
} 
